// Keeps login secrets out of Sentry, on the server and in the browser.
//
// Some URLs are credentials: /autologin/<login code>, /reset/<type>/<recovery
// code>, /api/recoverycode/<type>/<recovery code>, /invitation/<code> and
// links carrying ?token= or ?invite=. Sentry records the request URL, the
// transaction name, breadcrumbs and span data, so every string in an event is
// cleaned before it is sent. Cookies, the authorization header and the
// request body (login forms carry passwords) are dropped.
const REDACTED = '[redacted]';

// The segment after these path prefixes is a secret.
const SECRET_PATH = /(\/(?:autologin|invitation|reset\/[^/?#\s"']+|recoverycode\/[^/?#\s"']+)\/)[^/?#\s"']+/gi;

// Query parameters that carry a secret.
const SECRET_QUERY = /([?&](?:token|invite|invitation_code|code|signature|secret|access_token|refresh_token|key)=)[^&#\s"']*/gi;

const scrubString = (text) =>
  text
    .replace(SECRET_PATH, `$1${REDACTED}`)
    .replace(SECRET_QUERY, `$1${REDACTED}`);

const scrubValue = (value, depth = 0) => {
  if (typeof value === 'string') {
    return scrubString(value);
  }
  if (!value || typeof value !== 'object' || depth > 12) {
    return value;
  }
  if (Array.isArray(value)) {
    return value.map((item) => scrubValue(item, depth + 1));
  }
  const out = {};
  Object.keys(value).forEach((key) => {
    out[key] = scrubValue(value[key], depth + 1);
  });
  return out;
};

// For Sentry's beforeSend and beforeSendTransaction.
exports.scrubSentryEvent = (event) => {
  const cleaned = scrubValue(event);
  if (cleaned && cleaned.request) {
    delete cleaned.request.cookies;
    delete cleaned.request.data;
    if (cleaned.request.headers) {
      ['cookie', 'Cookie', 'authorization', 'Authorization'].forEach((name) => {
        delete cleaned.request.headers[name];
      });
    }
  }
  return cleaned;
};

// For Sentry's beforeBreadcrumb.
exports.scrubSentryBreadcrumb = (breadcrumb) => scrubValue(breadcrumb);

exports.scrubSentryString = scrubString;
